import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Upload,
  Icon,
  message,
} from 'antd';
// import styles from './style.less';
import { s3Host } from "../../../../utils";

const beforeUpload = (file) => {
  const isLt10M = file.size / 1024 / 1024 < 10;
  if (!isLt10M) {
    message.error('Зурагны хэмжээ 10MB ээс бага байх ёстой');
  }
  return isLt10M;
};

class SingleImageWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageUrl: '',
      loading: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.value && nextProps.value !== '') {
      this.props.onChange('');
    }
    this.setState({ imageUrl: nextProps.value });
  }


  handleRemove = (file) => {
    this.setState(({ fileList }) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      this.props.onChange(newFileList);
      return {
        fileList: newFileList,
      };
    });
  }

  handleChange = (info) => {
    let { file } = info;

    if (file.status === 'uploading') {
      this.setState({ loading: true }, this.props.onChange('loading'));
      return;
    }
    if (info.file.status === 'done') {
    // // 2. read from response and show file link
      const newfile = file.response && file.response.data.link;

      this.setState({ imageUrl: newfile, loading: false }, this.props.onChange(newfile));
    }
  }


  render() {
    const { imageUrl } = this.state;
    const uploadButton = (
      <div>
        <Icon type={this.state.loading ? 'loading' : 'plus'} />
        <div className="ant-upload-text">Upload</div>
      </div>
    );
    return (
      <Upload
        name="file"
        listType="picture-card"
        className="avatar-uploader"
        accept="image/*"
        showUploadList={false}
        action="/rest/store_product/upload_image"
        beforeUpload={beforeUpload}
        onChange={this.handleChange}
      >
        {(imageUrl && imageUrl !== 'loading') ? <img width="100%" src={`${s3Host}${imageUrl}`} alt="" /> : uploadButton}
      </Upload>
    );
  }
}

SingleImageWidget.defaultProps = {
  value: '',
};

SingleImageWidget.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default SingleImageWidget;



// WEBPACK FOOTER //
// ./src/components/Form/Widgets/SingleImageWidget/index.js